// removed by extract-text-webpack-plugin
module.exports = {"Menu":"style__Menu___20Zqx","Additional":"style__Additional___1ZcHi","Title":"style__Title___3IZSL","Checkboxes":"style__Checkboxes____tEfp","Checkbox":"style__Checkbox___1NhII","Button":"style__Button___105uL","Header":"style__Header___1Cptt","ChessFilterTitle":"style__ChessFilterTitle___3HkeS","Icon":"style__Icon___3tn8j","Active":"style__Active___24c90","CheckboxesInChess":"style__CheckboxesInChess___2Punw","FirstColumn":"style__FirstColumn___gbmpr","SecondColumn":"style__SecondColumn___V9JI8","ThirdColumn":"style__ThirdColumn___XcSJE","ButtonWrap":"style__ButtonWrap___3YMbu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/ViewType/style.scss
// module id = 1406
// module chunks = 0